import DownloadButton from "../DownloadButton";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";

export const ProcessCardInvoiceLayout = ({
  headDetails,
  itemDetails,
  rowData,
  invoiceTableData,
}) => {
  const organizationData = JSON.parse(localStorage.getItem("organisation"));
  const visibleFields = rowData.filter((field) => !field.is_internal_field);

  const formatCompanyAddress = (companyData) => {
    if (!companyData) return "N/A";

    const parts = [
      companyData.address?.trim(),
      companyData.city?.trim(),
    ].filter(Boolean);

    const pin = companyData.pincode ? `- ${companyData.pincode}` : "";

    return parts.length > 0 || pin
      ? `${parts.join(", ")} ${pin}`.trim()
      : "N/A";
  };

  return (
    <div className="invoice-container">
      <h2 className="invoice-title" style={{ textAlign: "center" }}>
        Process Card
      </h2>

      <div className="invoice-box">
        <div className="invoice-left">
          <div className="invoice-logo-container">
            <img
              src={organizationData?.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="invoice-logo-content"
            />
          </div>
          <div>
            <h3 className="invoice-company-name">
              {organizationData?.name || "N/A"}
            </h3>
            <p className="invoice-company-address">
              {formatCompanyAddress(organizationData)}
              <br />
              GSTIN: {organizationData?.gst_no || "N/A"}
              <br />
              State: {organizationData?.state || "N/A"}
            </p>
          </div>
        </div>

        <div className="invoice-right">
          <div className="purchase-detail border-bottom">
            <p className="detail-label">
              <strong>Process Card No:</strong>
            </p>
            <div className="detail-value">
              {headDetails?.process_card_no || "N/A"}
            </div>
          </div>
          <div className="purchase-detail">
            <p className="detail-label">
              <strong>Product Name:</strong>
            </p>
            <div className="detail-value">
              {headDetails?.product_name || "N/A"}
            </div>
          </div>
        </div>
      </div>

      <div className="invoice-supplier-details-container report-product-details-container">
        <div
          className="invoice-supplier-section report-header-section"
          style={{ borderRightWidth: "0px", borderBottomWidth: "0px" }}
        >
          <h4 className="invoice-section-title">Product Description:</h4>
          <span className="invoice-section-text report-header-text">
            {headDetails?.product_desc || "N/A"}
          </span>
        </div>
      </div>

      <div className="invoice-overflow-x-scroll">
        <table className="invoice-table">
          <thead className="invoice-thead">
            <tr>
              <th className="invoice-th" style={{ borderLeftWidth: "0px" }}>
                No.
              </th>
              {visibleFields.map((field, index) => (
                <th
                  key={field.field_name}
                  className="invoice-th"
                  style={
                    index === visibleFields.length - 1
                      ? { borderRightWidth: "0px" }
                      : {}
                  }
                >
                  {field.title || field.field_name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itemDetails.map((item, index) => (
              <tr key={index}>
                <td className="invoice-td" style={{ borderLeftWidth: "0px" }}>
                  {index + 1}
                </td>
                {visibleFields.map((field, idx) => (
                  <td
                    key={field.field_name}
                    className="invoice-td"
                    style={
                      idx === visibleFields.length - 1
                        ? { borderRightWidth: "0px" }
                        : {}
                    }
                  >
                    {item[field.field_name] || "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>

      <div className="invoice-buttons" style={{ paddingTop: "40px" }}>
        <DownloadButton
          tableData={invoiceTableData}
          fileName="process card"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".enquiry-page-container"
        />
      </div>
    </div>
  );
};